import React from 'react';
import { User } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const MODULE_TITLES = {
  'dashboard': 'Dashboard',
  'user-management': 'User Management',
  'permissions-management': 'User Permissions',
  'material-management': 'Gemstone & Materials',
  'category-management': 'Product Categories',
  'vendor-management': 'Vendor Details',
  'vendor-ledger': 'Vendor Ledger',
  'accounting-summary': 'Accounting Summary',
  'upload-profiles': 'Upload Profiles',
  'view-inventory': 'View Inventory',
  'add-inventory': 'Add Inventory',
  'upload-inventory': 'Upload Inventory',
  'indian-billing': 'INR Billing',
  'us-billing': 'USD Billing',
  'estimate-cart': 'Multi-Item Billing',
  'billing-history': 'Billing History',
  'jewelry-returns': 'Customer Returns',
  'inr-estimate': 'INR Estimate',
  'usd-estimate': 'USD Estimate',
  'view-estimates': 'View Estimates',
  'available-stock': 'Available Stock',
  'sold-items': 'Sold Items',
  'item-aging': 'Item Aging Report',
  'vendor-stock': 'Vendor Stock',
  'sales-report': 'Sales Report',
  'customer-list': 'Customer List',
  'gold-rate': 'Gold Rate',
  'dollar-rate': 'Dollar Rate',
  'manual-rate-entry': 'Manual Rate Entry',
  'exhibition-reconciliation': 'Reconciliation',
  'barcode-generator': 'Barcode Generator',
  'inventory-upload': 'Inventory Upload',
  'missing-images': 'Missing Photos',
  'billing-settings': 'Billing Settings',
  'vendor-import': 'Vendor Import',
  'scheme-management': 'Manage Schemes',
  'scheme-enroll': 'Enroll Customer',
  'scheme-payment': 'Record Payments',
  'scheme-dashboard': 'My Schemes',
  'scheme-redemption': 'Redemptions',
  'scheme-reports': 'Scheme Reports',
};

const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  manager: 'Manager',
  user: 'User',
};

const ROLE_COLORS = {
  super_admin: 'bg-purple-100 text-purple-800',
  admin: 'bg-red-100 text-red-800',
  manager: 'bg-blue-100 text-blue-800',
  user: 'bg-green-100 text-green-800',
};

const Header = ({ currentModule }) => {
  const { user } = useAuth();
  const title = MODULE_TITLES[currentModule] || currentModule;

  return (
    <div className="bg-white shadow-sm border-b border-gray-200 px-4 py-3 flex items-center justify-between sticky top-0 z-30 print:hidden">
      <div className="flex items-center gap-3">
        <h2 className="text-base font-semibold text-gray-800">{title}</h2>
      </div>

      <div className="flex items-center gap-2">
        <User size={15} className="text-gray-400" />
        <span className="text-sm text-gray-600">{user?.username}</span>
        <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${ROLE_COLORS[user?.role] || 'bg-gray-100 text-gray-800'}`}>
          {ROLE_LABELS[user?.role] || user?.role}
        </span>
      </div>
    </div>
  );
};

export default Header;
